import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=96464613
const initialState: {
  qr_code?: string
  amount?: string
  currency?: string
  order_id?: string
} = {}
export const get_pandapay_qr_info = createAsyncThunk(
  '/live/pay/get_pandapay_qr_info',
  async (order_id: string, store) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/get_pandapay_qr_info',
      {
        ...store.getState().env.deviceinfo,
        order_id,
      }
    )
    return resp.data.data
  }
)

export const Wallet2PandapaySlice = createSlice({
  name: 'Animal_Panda',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_pandapay_qr_info.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
        order_id: action.meta.arg,
      })
    })
  },
})
export const Wallet2PandapaySliceActions = Wallet2PandapaySlice.actions
export default Wallet2PandapaySlice.reducer
export const useWallet2PandapayState = () => {
  const data = useSelector((state) => state.Animal_Panda)
  return data
}
